import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DisplayProductDataService } from "../../display-product-data.service";
import { Store } from "@ngrx/store";
import { inject, Injectable } from "@angular/core";
import { mergeMap, map, catchError, of, take, concatAll, toArray } from "rxjs";
import { Accessory, AccessoryDetail } from "../../pump-data.model";
import { selectAccessory } from "./accessory.selector";
import * as AccessoryActions from './accessory.actions';

@Injectable()
export class AccessoryEffects {

  private displayProductData = inject(DisplayProductDataService);
  private actions$ = inject(Actions);
  private store = inject(Store);

    loadAccessories$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AccessoryActions.loadAccessories),
        mergeMap(() =>
          this.displayProductData.getAccessoryList().pipe(
            map((data: Accessory[]) =>
              AccessoryActions.loadAccessoriesSuccess({ data })
            ),
            catchError(error =>
              of(AccessoryActions.loadAccessoriesFailure({ error }))
            )
          )
        )
      )
    );

    loadAllAccessoryData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AccessoryActions.loadAllAccessory),
        mergeMap(() =>
          this.store.select(selectAccessory).pipe(
            map((data) => data.accessories),
            take(1),
            concatAll(),
            mergeMap(item =>
              this.displayProductData.getAccessoryItem(item.uuid)
            ),
            toArray(),
            map((result: AccessoryDetail[]) => {
              const data = result.map(item => ({
                ...item.versions[0],
                file: item.name,
                uuid: item.uuid
              }));

              return AccessoryActions.loadAllAccessorySuccess({ data });
            }),
            catchError(error =>
              of(AccessoryActions.loadAllAccessoryFailure({ error }))
            )
          )
        )
      )
    );
  
}